<template>
  <div>
    <slot name="header" />
    <!-- Loaded -->
    <div v-if="!isLoading && listLength">
      <div class="mx-auto px-4 max-w-6xl sm:px-6 lg:px-8">
        <div class="flex flex-col mt-4">
          <div class="flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <slot name="table" />
                </div>
                <slot name="pagination" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NeueLoading v-if="isLoading" :loading="true">
      <div class="mx-auto mt-4 flex max-w-6xl flex-col gap-4 px-4 sm:px-6 lg:px-8" aria-hidden="true">
        <div v-for="row in 3" :key="row" class="rounded-lg border border-gray-200 bg-white px-6 py-5 shadow-sm">
          <div class="h-4 w-40 rounded bg-gray-200" />
          <div class="mt-3 h-3 w-56 rounded bg-gray-100" />
          <div class="mt-8 h-24 rounded-md bg-gray-50" />
        </div>
      </div>
    </NeueLoading>
    <!-- Empty -->
    <div v-if="!isLoading && !listLength" class="flex justify-center flex-col h-3/4">
      <SimpleEmptyState
        :heading="emptyStateHeading"
        :description="emptyStateDescription"
        icon="ClipboardDocumentListIcon"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'

export default defineComponent({
  components: { NeueLoading },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    listLength: {
      type: Number,
      required: true
    },
    emptyStateHeading: {
      type: String,
      required: false,
      default: 'No items yet'
    },
    emptyStateDescription: {
      type: String,
      required: false,
      default: "Get started by clicking 'New'"
    }
  }
})
</script>
